if (!customElements.get('header-promotions')) {
	customElements.define('header-promotions', class extends HTMLElement {
		connectedCallback() {
			this.controller?.abort();
			this.controller = new AbortController();
			const options = { signal: this.controller.signal };
			const details = this.querySelector('details');
			const summary = this.querySelector('summary');
			if (!details || !summary) return;
			const desktop = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
			const header = this.closest('.header-section');
			const close = () => {
				clearTimeout(this.closeTimer);
				details.open = false;
			};
			const open = () => {
				clearTimeout(this.closeTimer);
				if (details.open) return;
				if (!this.classList.contains('header-promotions--mobile')) {
					window.themeCore?.EventBus?.emit('Toggle:headerToggleMenuDrawer:close');
				}
				details.open = true;
			};
			const canHover = () => desktop.matches && !this.classList.contains('header-promotions--mobile') && header?.querySelector('[data-open-menu-type]')?.dataset.openMenuType === 'hover';

			this.addEventListener('pointerenter', (event) => {
				clearTimeout(this.closeTimer);
				if (event.pointerType === 'mouse' && canHover()) open();
			}, options);

			this.addEventListener('pointerleave', (event) => {
				if (event.pointerType !== 'mouse' || !canHover()) return;
				this.closeTimer = setTimeout(() => {
					if (!this.contains(document.activeElement)) close();
				}, 200);
			}, options);

			summary.addEventListener('click', (event) => {
				event.preventDefault();
				if (details.open) close();
				else open();
			}, options);

			summary.addEventListener('keydown', (event) => {
				if (event.key !== 'ArrowDown') return;
				event.preventDefault();
				open();
				this.querySelector('a[href]')?.focus();
			}, options);

			this.addEventListener('keydown', (event) => {
				if (event.key !== 'Escape' || !details.open) return;
				event.preventDefault();
				event.stopPropagation();
				close();
				summary.focus();
			}, options);

			this.addEventListener('focusout', (event) => {
				if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
			}, options);

			document.addEventListener('pointerdown', (event) => {
				if (!this.contains(event.target)) close();
			}, options);

			header?.addEventListener('pointerover', (event) => {
				if (!canHover() || this.contains(event.target)) return;
				if (event.target.closest('.header-menu__list--main > li')) close();
			}, options);

			window.addEventListener('blur', close, options);
			desktop.addEventListener('change', close, options);
		}

		disconnectedCallback() {
			clearTimeout(this.closeTimer);
			this.controller?.abort();
		}
	});
}
